import { render, staticRenderFns } from "./DDM.vue?vue&type=template&id=79aeb78c&"
import script from "./DDM.vue?vue&type=script&lang=js&"
export * from "./DDM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports